import React, { useEffect, useRef } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { about, home, contact, chatUsers, userprofile } from "../../const";
import moment from "moment";

const Footer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const width = useRef(window.innerWidth);
  const canOpenProfile = ["customer", "team_leader", "branch_leader"].includes(
    localStorage.getItem("slug")
  );
  // useEffect(() => {
  //   dispatch(getPages());
  // }, []);
  const { getSocialMediaSettingsData } = useSelector(
    (state) => state.commonReducer
  );
  return (
    <>
      <footer>
        {/* fixed nav start */}
        <nav className="mobile-bottom-nav">
          <div className="mobile-bottom-nav__item">
            <div className="mobile-bottom-nav__item-content">
              <Link to={chatUsers}>
              <i className="bi bi-people-fill"></i>
              </Link>
            </div>
          </div>
          <div className="mobile-bottom-nav__item">
            <div className="mobile-bottom-nav__item-content">
              <i onClick={() => window.location.reload()} className="bi bi-arrow-clockwise"></i>
            </div>
          </div>

          <div className="mobile-bottom-nav__item">
            <div className="mobile-bottom-nav__item-content">
            <i className="bi bi-person-circle" onClick={() => canOpenProfile && navigate(userprofile)}></i>
            </div>
          </div>
        </nav>
        {/* fixed nav end */}
      </footer>
    </>
  );
};

export default Footer;
